import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { VenueRatesService } from '../venue-rates.service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { ToastModule } from 'primeng/toast';
import { DatepickerService } from 'app/Shared/Component/datepicker-calendar/datepicker.service';
import { DatePickerModule } from 'primeng/datepicker';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonValidators } from 'app/Shared/Constant/common-validators';
import { VenueRate } from '../venue-rate.model';
import { map } from 'rxjs';

@Component({
  selector: 'app-add-edit-view-venue-rates',
  imports: [DialogModule,CommonModule, ButtonModule, FormsModule,
          MatProgressSpinnerModule, MatTooltipModule, ConfirmDialogModule, DrawerModule, ToastModule,DatePickerModule, ReactiveFormsModule],
  templateUrl: './add-edit-view-venue-rates.component.html',
  styleUrl: './add-edit-view-venue-rates.component.scss'
})
export class AddEditViewVenueRatesComponent implements OnInit, OnChanges {
  @Input('columns') columns: any;
  @Input() showDialog: boolean = false;
  @Input() rowData: VenueRate = new VenueRate();
  @Input() mode: any = 'add'

  @Output() visibilityChange = new EventEmitter<boolean>();
  
  venueForm!: FormGroup;
  formSubmitted = false;
  effectiveDate: any;
  header: any = "Add Venue Rate"
  isVenueRatesLoadingResults: boolean = false;

  constructor(public venueRatesService: VenueRatesService, private userService: UserService,
    private messageService: MessageService,private datepickerService: DatepickerService,private fb: FormBuilder){
    
  }
  
  
  
  ngOnInit(): void {
    this.formSubmitted = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['showDialog'] && changes['showDialog'].currentValue === true) {
        this.buildForm();
        this.formSubmitted = false;
        if(this.mode === 'add') {
          this.header = "Add Venue Rate";
        } else if(this.mode === 'edit') {
          this.header = "Edit Venue Rate";
        } else {
          this.header = "View Venue Rate Details";
        }
      }
  }


buildForm() {
    const formControls: any = {};
    
    this.columns.forEach((col: any) => {
      if (col.ui_columnname !== 'Action') {
        const validators = [];
        
        if (col.isrequired === 'true') {
          validators.push(CommonValidators.requiredTrim());
        }
        
      
        if (col.mappingkey === 'rate') {
          validators.push(CommonValidators.decimalRate());
        }

        if (col.mappingkey === 'effectiveDate') {
          validators.push(CommonValidators.dateFormat());
        }


        const isVenueNameDisabled = col.mappingkey === 'venueName' && 
                                    (this.mode === 'view' || this.mode === 'edit');

         const controlConfig: any = {
          value: this.rowData[col.mappingkey as keyof VenueRate] || '',
          disabled: this.mode == 'view' || col.disabled === true || isVenueNameDisabled
        };
        
        formControls[col.mappingkey] = [controlConfig, validators];

      }
    });
    
    this.venueForm = this.fb.group(formControls);
  }

  onSave() {
    this.formSubmitted = true;

    Object.keys(this.venueForm.controls).forEach(key => {
      const control = this.venueForm.get(key);
      if (control && typeof control.value === 'string') {
        control.setValue(control.value.trim(), { emitEvent: false });
      }
    });
    
    this.venueForm.updateValueAndValidity();

    if (this.venueForm.valid) {
      const rawDate = this.venueForm.value.effectiveDate;
      let effectiveDate: string;

      if (rawDate instanceof Date) {
        effectiveDate = [
          rawDate.getFullYear(),
          String(rawDate.getMonth() + 1).padStart(2, '0'),
          String(rawDate.getDate()).padStart(2, '0')
        ].join('-');
      } else {
        const strVal = rawDate.toString().trim();
        if (/^\d{8}$/.test(strVal)) {
          effectiveDate = `${strVal.substring(0, 4)}-${strVal.substring(4, 6)}-${strVal.substring(6, 8)}`;
        } else {
          effectiveDate = strVal;
        }
      }

      let payloadObj = {
        "id" : this.rowData.id,
        "firmMPID" : this.userService.getActiveMPID(),
        "venueName" : this.venueForm.getRawValue()['venueName'],
        "venueMPID" : this.venueForm.value['venueMPID'],
        "rate" : this.venueForm.value['rate'],
        "materialAspect" : this.venueForm.value['materialAspect'],
        "effectiveDate" : effectiveDate,
        "user" : this.userService.getUserName(),
      }

      this.isVenueRatesLoadingResults = true;

      if(this.mode === 'add') {
        this.venueRatesService.getAdd(payloadObj)
          .pipe(map((response: Response) => {
            return response;
          }))
          .subscribe({
            next: (data: any) => {
              this.isVenueRatesLoadingResults = false;
              if (data.status) {
                this.venueRatesService.reloadData();
                this.messageService.add({ 
                  severity: 'success', 
                  summary: 'Success', 
                  detail: 'Record saved successfully' 
                });
                this.onClose();
              } else {
                this.messageService.add({ 
                  severity: 'error', 
                  summary: 'Error', 
                  detail: data.data 
                });
              }
            },
            error: (err: HttpErrorResponse) => {
              this.isVenueRatesLoadingResults = false;
              this.messageService.add({ 
                severity: 'error', 
                summary: 'Error', 
                detail: err.message 
              });
            }
          });
      } else if(this.mode === 'edit') {
        this.venueRatesService.getEdit(payloadObj)
          .pipe(map((response: Response) => {
            return response;
          }))
          .subscribe({
            next: (data: any) => {
              this.isVenueRatesLoadingResults = false;
              if (data.status) {
                this.venueRatesService.reloadData();
                this.messageService.add({ 
                  severity: 'success', 
                  summary: 'Success', 
                  detail: 'Record updated successfully' 
                });
                this.onClose();
              } else {
                this.messageService.add({ 
                  severity: 'error', 
                  summary: 'Error', 
                  detail: data.data 
                });
              }
            },
            error: (err: HttpErrorResponse) => {
              this.isVenueRatesLoadingResults = false;
              this.messageService.add({ 
                severity: 'error', 
                summary: 'Error', 
                detail: err.message 
              });
            }
          });
      }

    } else {
      Object.keys(this.venueForm.controls).forEach(key => {
        this.venueForm.controls[key].markAsTouched();
      });
      
      this.messageService.add({ 
        severity: 'warn', 
        summary: 'Validation Error', 
        detail: 'Please fill all required fields correctly' 
      });
    }
  }

  onClose() {
    this.formSubmitted = false;
    this.visibilityChange.emit(false);
    if (this.venueForm) {
      this.venueForm.reset();
    }
  }

  hasError(fieldName: string, errorType: string): boolean {
    const control = this.venueForm.get(fieldName);
    return !!(control && control.hasError(errorType) && (control.touched || this.formSubmitted));
  }

  isFieldInvalid(fieldName: string): boolean {
    const control = this.venueForm.get(fieldName);
    return !!(control && control.invalid && (control.touched || this.formSubmitted));
  }

  getErrorMessage(col: any): string {
    const control = this.venueForm.get(col.mappingkey);
    
    if (!control || !control.errors || (!control.touched && !this.formSubmitted)) {
      return '';
    }

    if (control.errors['required']) {
      return `${col.ui_columnname} is required`;
    }
    
    if (control.errors['whitespace']) {
      return `${col.ui_columnname} cannot be empty or whitespace only`;
    }
    
    if (control.errors['invalidRate']) {
      return 'Allowed max 12 digits, up to 6 decimals';
      
    }
    
    if (control.errors['rateNegative']) {
      return 'Rate cannot be negative';
    }

    if (control.errors['invalidDate']) {
      return 'Date must be in YYYY-MM-DD or YYYYMMDD';
    }

    return 'Invalid value';
  }


onDateInput(event: any, controlName: string) {
  const value = event.target.value?.trim();

  if (/^\d{8}$/.test(value)) {
    const year = parseInt(value.substring(0, 4), 10);
    const month = parseInt(value.substring(4, 6), 10);
    const day = parseInt(value.substring(6, 8), 10);

    this.venueForm.get(controlName)?.setValue(new Date(year, month - 1, day));
  }
}


}
